<div class="activity-page" [class.activity-page--compact]="compact">
  <section class="activity" aria-labelledby="activityTitle">
    <header class="activity__header">
      @if (compact) {
        <h2 class="activity__title" id="activityTitle">Notifications</h2>
      } @else {
        <h1 class="activity__title" id="activityTitle">Notifications</h1>
      }

      <div class="activity__tabs" role="group" aria-label="Filter activity">
        @for (option of filters; track option.value) {
          <button
            type="button"
            class="activity__tab"
            [class.is-active]="filter() === option.value"
            [attr.aria-pressed]="filter() === option.value"
            (click)="setFilter(option.value)">
            {{ option.label }}
          </button>
        }
      </div>
    </header>

    <div class="activity__body" [attr.aria-busy]="store.isLoading">
      <!-- Only this short line is live; making the whole list live would read every item out on each change. -->
      <p class="sr-only" role="status">{{ announcement }}</p>
      @if (views.length) {
        <ul class="activity__list">
          @for (view of views; track $index) {
            <li class="activity__item" tabindex="-1">
              <ut-activity-item [view]="view" [unread]="isUnread($index)"></ut-activity-item>
            </li>
          }
        </ul>
      } @else if (!store.isLoading) {
        <div class="activity__empty">
          <p class="activity__empty-title">You don't have any recent activity.</p>
          <p class="activity__empty-text">Check out the community page to share content and meet other uTesters.</p>
          <a class="ut-btn ut-btn--secondary" uiSref="community">Community Page</a>
        </div>
      }

      @if (store.isLoading) {
        <p class="activity__loading">Loading activity…</p>
      } @else if (compact) {
        @if (views.length) {
          <a class="ut-btn ut-btn--secondary activity__more" uiSref="activity">View More</a>
        }
      } @else if (!store.isLastPage) {
        <button type="button" class="ut-btn ut-btn--secondary activity__more" (click)="loadMore()">View More</button>
      }
    </div>
  </section>
</div>
